<script setup>
import { Inertia } from '@inertiajs/inertia';
import { InformationCircleIcon } from "@heroicons/vue/outline"
import { ref } from 'vue'

import MembershipApplicationList from '@/Components/Models/MembershipApplication/List'

const props = defineProps({
    applications: {
        type: Array,
        default: () => ([]),
    },
})

function itemClicked(item){
    Inertia.visit('/membership-applications/' + item.id)
}
</script>

<template>
    <SectionCard :full-width="true">

        <template #header>
			<div class="flex justify-between items-center">
				<span class="text-lg font-medium text-gray-900 mb-0">Membership Applications</span>
			</div>
        </template>
        
		<MembershipApplicationList 
			:items="applications" 
			@item-clicked="itemClicked" 
		/>

    </SectionCard>
</template>